import { addStyles } from 'ethcss'
import { IStyles } from 'theme'
import { defaultThemeStyles } from '../../molecules/DownloadModal/DownloadProgressModal.theme'

export const styles: IStyles = {
    advertisementItem: {
        padding: '10px 30px',
        listStyle: 'none',
        borderBottom: `1px solid var(--var-module-app-component-download-progress-style-border, ${defaultThemeStyles.border})`,
    },
    advertisementItemHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    advertisementItemLeft: {
        display: 'flex',
    },
    advertisementItemRight: {
        display: 'flex',
    },
    icon: {
        marginRight: '16px',
    },
    advertisementName: {
        lineHeight: '1.3',
    },
    status: {
        width: '70px',
        textAlign: 'center',
    },
    opened: {
        transform: 'rotate(180deg)',
    },
}

addStyles(styles)
